import { helpers, requiredIf } from '@vuelidate/validators'

export const requiredIfValidator = (...params: Parameters<typeof requiredIf>) =>
  helpers.withMessage('Es requerido', helpers.withParams({}, requiredIf(...params)))
